 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		1: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"common","2":"core-js-js","3":"css-shim-206ea950-3169f23e-js","4":"dom-96781eef-a2fb04dd-js","5":"dom-js","6":"focus-visible-70713a0c-js","7":"hardware-back-button-5afe3cb0-js","8":"index-69c37885-js","9":"input-shims-a4fc53ac-js","10":"ios-transition-504cdd09-js","12":"md-transition-fea2bbfb-js","13":"pages-choose-level-choose-level-module-ngfactory","14":"pages-custom-popup-custom-popup-module-ngfactory","15":"pages-home-home-module-ngfactory","16":"pages-match-words-match-words-module-ngfactory","17":"pages-missing-letter-missing-letter-module-ngfactory","18":"pages-select-game-select-game-module-ngfactory","19":"pages-select-topic-select-topic-module-ngfactory","20":"pages-sentence-builder-sentence-builder-module-ngfactory","21":"pages-story-builder-story-builder-module-ngfactory","24":"shadow-css-4889ae62-23996f3f-js","25":"status-tap-32c72c43-js","27":"swipe-back-35ad8e37-js","28":"swiper-bundle-8bab85e6-js","29":"tap-click-ca00ce7f-js"}[chunkId]||chunkId) + "." + {"0":"4a69155790854e652227","2":"1639f5ab84c95d7038fb","3":"173e490e874963e7dbb4","4":"8a6b51d2a5f0f90fac6f","5":"ac5d66bc5246c6beb17f","6":"5ea08edf345a2ead2fa8","7":"ce79c4c5422c01c9de09","8":"e69d6871ac46bcc0d2fc","9":"1efdfbc59da17be85739","10":"3701e1f40136f8d37c91","12":"8d42cc0008a02aab6ec0","13":"d0450f87511117af9e82","14":"08be12cbb5ca5ea4e1c9","15":"15a8ce4aa4752805c873","16":"02f66ef97a419c78b4cf","17":"62101fc37c5de3091247","18":"762195dc6b6bb10189e1","19":"a9ac6d1e465de30a9805","20":"2ea6b0d480ef7bafa3b5","21":"dad1abd7f583dfb055a0","24":"e722cdac986da61dd800","25":"302afa312fdca013c988","27":"cecbcf271c19f15c0f35","28":"d30fb51508bb30915057","29":"d8e96d2666b28a2457b6","30":"6aa647b2bec130943949","31":"1ab49ef47ccb80f83ea0","32":"3116d2d313b310a596d7","33":"5b5813a064af257ac556","34":"564690b55f6c6f4107b9","35":"db13ee50fd16b722a7c8","36":"d0cab8edf8363048e322","37":"aaeea997d717fc61b046","38":"24b9c3dc9ad77ca48c88","39":"2e338899319587ab8f11","40":"6f51a9efc759f2dacc3d","41":"f68502c282bbe317d9cb","42":"9e4dd2fbc5e190c861d8","43":"528297809675fab974ef","44":"11a72dfb0e5c347e3ca3","45":"cd0738f91128a3fc9fb3","46":"676c4f18ff6889cee12f","47":"96427b2441b090236f27","48":"a88beabcc08d346ce870","49":"278d1a2150ec1605f6ed","50":"389a61ea98b268e763c1","51":"6233b4ebf396ea4c0ac5","52":"4e90eab8e91432d03594","53":"0d0a3722c900f543cc6d","54":"82c875adf927bd19d5fe","55":"5376156a3c5311bdaa8f","56":"d16a8cb425b09d31f5c5","57":"90f2aa39d9d7c024e9e8","58":"17d4afa6375c7e19b90b","59":"2005ae4d1516446e2e00","60":"edc02bec9b204b753368","61":"7ed0328b57cdf0585279","62":"a30b801321ffd84b7bf9","63":"f9c7a14973b7c39ed7ce","64":"8d19a7bfbdb7dc8cabcb","65":"2826babbe294cc2be2a6","66":"24c41c65a3441a77ce8f","67":"185756e782b83413c50c","68":"a58f36989ccb4713581f","69":"62af1a41cb6872cc1479","70":"edb8a59d40f3c17b8d99","71":"a13c1f615bbc30710866","72":"491b53bf657cb0b6528f","73":"6b401618e113a2d95c9a","74":"2d7be6e7408c96d33c00","75":"30d4c7d26c9b0245f91e","76":"029659147c6152b0a457","77":"0b14b246a2c28f4e0f05","78":"25794a1cbe9e240bf985","79":"206732f0cf43aa8dacac","80":"84a053440e941d621764","81":"85cc79d351cc3c312203","82":"3b3262b8e0a97d8ae911","83":"5f19b2895e1d1f7aa81f","84":"5d0e233a0cbe5f6fcd64","85":"22b105b5b323569fb217","86":"a55fcf5713c5c5955b5a","87":"61b2c91bd0e0e83abee9","88":"5487a140b57549725447","89":"2eb9d398a5980633e4a4","90":"98c38ed0c52e3da38b95","91":"7de380ff328f29e9d28f","92":"85f2f94db4d7d61be82c","93":"e6e2678d6c69469d4b85","94":"8ced4ebd4d6763199a21","95":"3e49bb54a210a54cc4b0","96":"a9b7d351aee3c245a057","97":"f0dc3b54ae137024b2a9","98":"5c550ff5eddaf3473b03","99":"d14406108b732645e151","100":"690282593a67a2181d9f","101":"c822f13d56ae154da67a","102":"f317209bbf232ad2f3de","103":"7f168a49e2162522d3a5","104":"a834abafd042c6131d62","105":"a594e359741917e25895","106":"a4912d525701b331e7d8","107":"7c59588c7477d8553f7c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
